var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.3 85",
    style: {
      enableBackground: "new 0 0 85.3 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:#818082;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#818082;}\n\t.st2{font-family:'Montserrat-SemiBold';}\n\t.st3{font-size:28px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1317.9489,
    y1: -689.5661,
    x2: 1400.9806,
    y2: -689.5661,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 732.23 1401.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD1D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#C9CBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#B9BBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#9EA0A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E9092"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51,1.1c-0.9-0.3-1.9,0.1-2.3,1c0,0.1-0.1,0.2-0.1,0.3c-0.5,1.5-1.2,2.9-1.7,4.4c-0.5,1.3-1.4,1.8-2.7,1.7 h-0.3c-3,0.2-6,0.3-9.1,0.5l-2.9-5.5c-0.7-1.3-1.3-1.6-2.7-1.2c-3.2,1-6.3,2.5-9.1,4.3c-0.5,0.3-0.9,0.7-1.3,1.1 c-0.6,0.6-0.7,1.5-0.4,2.2c0.9,2,1.8,4.1,2.5,5.9l-7.6,8.5c-1.9-0.6-4.1-1.3-6.2-1.9c-0.9-0.4-1.9,0-2.3,0.8c0,0,0,0.1,0,0.1 c-1.7,3.4-3,7-3.8,10.7c-0.3,1,0.2,2,1.2,2.4c0,0,0,0,0.1,0C4.3,37.3,6,38,7.9,38.7c0.5,0.1,0.9,0.6,0.8,1.1c0,0,0,0.1,0,0.1 c-0.1,0.8-0.1,1.7,0,2.5C8.8,45,9,47.6,9.2,50.3l-5.9,3.2c-0.9,0.5-1.3,1.1-1,1.9c1.2,3.8,2.9,7.4,5.1,10.7 c0.5,0.8,1.6,1.1,2.5,0.7c0.9-0.4,1.8-0.8,2.6-1.2c1.2-0.5,2.4-1,3.6-1.5c2.1,2.7,4.7,5,7.5,6.8c0.5,0.2,0.7,0.8,0.5,1.4 c-0.6,1.9-1.1,3.7-1.6,5.5c-0.4,1.4-0.2,2.2,1.1,2.7c2.7,1.1,5.5,2.2,8.3,3.1c0.9,0.3,1.8,0.4,2.6,0.4c0.9,0,1.7-0.5,1.9-1.4 c0.7-1.9,1.5-3.7,2.2-5.5c0.1-0.4,0.6-0.7,1-0.6l0,0c0.8,0.1,1.6,0.1,2.4,0.1c2.7-0.2,5.3-0.4,8.1-0.6l3.1,5.8 c0.3,0.9,1.3,1.4,2.2,1.2c0.1,0,0.2-0.1,0.3-0.2c3.5-1.2,6.9-2.8,10-4.8c0.9-0.4,1.4-1.5,0.9-2.5c0-0.1-0.1-0.2-0.2-0.3 c-0.8-1.9-1.6-3.8-2.4-5.5c-0.2-0.3-0.2-0.8,0.2-1c0,0,0.1,0,0.1,0c2.5-2.1,4.7-4.6,6.5-7.3c0.3-0.4,0.5-0.6,1-0.4 c2,0.6,4,1.2,6.1,1.8c0.9,0.3,1.9-0.1,2.2-1c1.7-3.4,3-7,3.8-10.7c0.4-1-0.1-2.1-1.1-2.4c-0.1,0-0.2-0.1-0.3-0.1 c-1.9-0.7-3.6-1.4-5.4-2.2c-0.3-0.1-0.7-0.6-0.7-0.9c0.3-3.5,0-7-0.7-10.5c0.6-0.3,1-0.6,1.5-0.9c1.5-0.8,3.1-1.6,4.6-2.5 c0.9-0.3,1.4-1.3,1-2.2c-0.1-0.1-0.1-0.2-0.2-0.4C82,27.1,81.2,25,80.2,23c-0.7-1.3-1.5-2.6-2.4-3.8c-0.8-1-1.4-1-2.6-0.5 c-1.8,0.8-3.6,1.5-5.4,2.3c-0.3,0.1-0.7,0-0.9-0.1c-2.2-2.5-4.7-4.8-7.4-6.7c-0.2-0.2-0.4-0.5-0.3-0.9c0.5-1.9,1.1-3.9,1.7-5.8 c0.4-1.3,0.2-2.1-1.1-2.6c-2.1-0.9-4.2-1.9-6.4-2.6C54,1.7,52.5,1.4,51,1.1L51,1.1L51,1.1z M66.4,50.9 C61.8,64.1,47.5,71,34.3,66.5S14.3,47.5,18.8,34.4c4.6-13.1,18.9-20.1,32.1-15.5S71,37.8,66.4,50.9L66.4,50.9 C66.4,50.9,66.4,50.9,66.4,50.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.69 88.71)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -307.7335 -34.0303)",
    className: "st1 st2 st3"
  }, "U"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearU);
export default __webpack_public_path__ + "static/media/gear-u.17c0f4d26daacccc0366154eddb94523.svg";
export { ForwardRef as ReactComponent };